export enum Locale {
  en = 'en',
  zhCN = 'zh'
}

export const langObj: { [lang: string]: string } = {
  [Locale.en]: 'EN',
  [Locale.zhCN]: '中文'
};
